import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function Presence() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="presence"
      data-testid="philosophy-section"
      ref={ref}
      className="relative py-24 sm:py-32 lg:py-40 px-6 sm:px-8 bg-pragti-surface scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5 }}
              className="font-mono text-xs tracking-[0.2em] uppercase text-pragti-accent mb-6"
              data-testid="philosophy-overline"
            >
              What pragti is
            </motion.p>

            <motion.h2
              initial={{ opacity: 0, y: 15 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight text-pragti-text"
              data-testid="philosophy-heading"
            >
              Not another chatbot.
              <br />
              A twin that fits
              <br />
              <span className="text-pragti-text-secondary font-light italic">
                your actual week.
              </span>
            </motion.h2>
          </div>

          <div className="lg:col-span-7 space-y-10">
            <motion.blockquote
              initial={{ opacity: 0, y: 15 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.25 }}
              className="border-l-2 border-pragti-accent/40 pl-6"
              data-testid="philosophy-quote"
            >
              <p className="font-heading text-lg sm:text-xl italic text-pragti-text leading-relaxed">
                &quot;Most days you are not short on ability. You are short on hours. pragti
                gives some of those hours back.&quot;
              </p>
            </motion.blockquote>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="space-y-5"
            >
              <p
                className="font-body text-base text-pragti-text-secondary leading-relaxed"
                data-testid="philosophy-text-1"
              >
                Your twin learns how you talk, what you care about at work, and what you
                need to keep straight at home. It can read the calendar you share, pick up
                email threads you connect, and answer in a voice that sounds like you.
              </p>
              <p
                className="font-body text-base text-pragti-text-secondary leading-relaxed"
                data-testid="philosophy-text-2"
              >
                Teams use pragti so good people do not burn out repeating themselves.
                Individuals use it to stay on top of work without missing what matters
                outside the office. You choose what to connect and what stays private.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
